import { ConsentItem } from 'src/pages/MainPage/components/ConsentForm/ConsentItem';

export default ConsentItem;
